import {useEffect, useState} from 'react';

export const useLoadI18 = (): boolean => {
  const [i18Loaded, setI18Loaded] = useState(false);

  useEffect(() => {
    const onSuccess = (): void => {
      setI18Loaded(true);
    };

    window.PMW.initI18next(window.PMW.LANGUAGE, onSuccess);
    window.PMW.initTracking();

    document.addEventListener(window.PMW.i18next_LOADED_EVENT, onSuccess);

    return (): void => {
      document.removeEventListener(window.PMW.i18next_LOADED_EVENT, onSuccess);
    };
  }, []);

  return i18Loaded;
};
